import * as React from "react";
import {
  Datagrid,
  List,
  Show,
  Create,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  NumberField,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  BooleanField,
  BooleanInput,
  DateTimeInput,
} from "react-admin";
import { CustomDeleteButton } from './CustomDeleteButtons';

const RoundFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="user_id" alwaysOn />
  </Filter>
);

export const RoundList = (props) => (
  <List {...props} filters={<RoundFilter />}>
    <Datagrid>
      <ReferenceField source="user_id" reference="users" label="Player">
        <TextField source="email" />
      </ReferenceField>
      <ReferenceField source="course_id" reference="courses" label="Golf Course">
        <TextField source="name" />
      </ReferenceField>
      <NumberField source="score" label="Score" />
      <NumberField source="adjusted_score" label="Adjusted Score" />
      <BooleanField source="is_9_holes" label="9 Holes" />
      <ShowButton label="" />
      <EditButton label="" />
      <CustomDeleteButton label="" redirect={false}/>
    </Datagrid>
  </List>
);

export const RoundShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="ID" />
      <ReferenceField source="user_id" reference="users" label="Player">
        <TextField source="email" />
      </ReferenceField>
      <ReferenceField source="course_id" reference="courses" label="Golf Course">
        <TextField source="name" />
      </ReferenceField>
      <NumberField source="score" label="Score" />
      <NumberField source="adjusted_score" label="Adjusted Score" />
      <BooleanField source="is_9_holes" label="9 Holes" />
      <TextField source="date" label="Play Date" />
    </SimpleShowLayout>
  </Show>
);

export const RoundCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput source="user_id" reference="users" label="Player">
        <SelectInput optionText="email" />
      </ReferenceInput>
      <ReferenceInput source="course_id" reference="courses" label="Golf Course">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <NumberInput source="score" label="Score" />
      <NumberInput source="adjusted_score" label="Adjusted Score" />
      <BooleanInput source="is_9_holes" label="9 Holes" />
      <DateTimeInput source="date" label="Play Date" />
    </SimpleForm>
  </Create>
);

export const RoundEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <ReferenceInput source="user_id" reference="users" label="Player">
        <SelectInput optionText="email" />
      </ReferenceInput>
      <ReferenceInput source="course_id" reference="courses" label="Golf Course">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <NumberInput source="score" label="Score" />
      <NumberInput source="adjusted_score" label="Adjusted Score" />
      <BooleanInput source="is_9_holes" label="9 Holes" />
      <DateTimeInput source="date" label="Play Date" />
    </SimpleForm>
  </Edit>
); 